import * as R from 'ramda';

export default function SchematicController(
  $filter,
  $q,
  $rootScope,
  alerts,
  userService,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  ssDialogService,
  loaderService,
  reportsDataService,
  editSchematicDialog,
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;

  vm.handleExpand = _handleExpand;
  vm.handleMoveUp = _handleMoveUp;
  vm.handleMoveDown = _handleMoveDown;
  vm.handleDownload = _handleDownload;
  vm.handleEdit = _handleEdit;
  vm.handleDelete = _handleDelete;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (vm.canExpand) {
      if (vm.schematic.hasImage) {
        vm.isExpanded = !vm.isExpanded;
      } else {
        bcpDataService.downloadSchematicContent(vm.schematic.documentId, -1).then((response) => {
          const fileData = JSON.parse(response.data);
          vm.schematic.imgByteArray = fileData.imgByteArray;
          vm.schematic.hasImage = true;
          vm.isExpanded = true;
        });
      }
    }
  }

  function _handleMoveUp() {
    loaderService.showViewLoader = true;
    bcpDataService.moveSchematicUp(vm.schematic.assessmentSchematicId).then((response) => {
      if (response.data === false) {
        alerts.error('An Error occurred while moving the Schematic up in the list.');
        loaderService.showViewLoader = false;
      } else {
        vm.isExpanded = false;
        $rootScope.$broadcast('refreshBCPSchematics');
        loaderService.showViewLoader = false;
      }
    });
  }

  function _handleMoveDown() {
    loaderService.showViewLoader = true;
    bcpDataService.moveSchematicDown(vm.schematic.assessmentSchematicId).then((response) => {
      if (response.data === false) {
        alerts.error('An Error occurred while moving the Schematic down in the list.');
        loaderService.showViewLoader = false;
      } else {
        vm.isExpanded = false;
        $rootScope.$broadcast('refreshBCPSchematics');
        loaderService.showViewLoader = false;
      }
    });
  }

  function _handleDownload() {
    bcpDataService.downloadSchematic(vm.schematic.documentId).then((response) => {
      reportsDataService.download(response);
    });
  }

  function _handleEdit($event) {
    ssDialogService.dialogs.bcp.editSchematicDialog = ssDialogService.alert(
      editSchematicDialog.getOptions($event, {
        customerId: vm.customerId,
        assessmentId: vm.assessmentId,
        schematic: vm.schematic,
        refreshCallback: _handleEditedSchematic,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editSchematicDialog);
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.confirmDeleteSchematicDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Schematic?',
        message: `Are you sure you want to delete the Schematic "${vm.schematic.name}"?`,
        handleYesClick() {
          _handleConfirmDelete(vm.schematic);
        },
        handleNoClick: _closeDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteSchematicDialog);
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _handleConfirmDelete(schematic) {
    return bcpDataService.deleteSchematic(vm.schematic.assessmentSchematicId)
      .then(() => {
        alerts.success('The Schematic has been deleted successfully.');
        $rootScope.$broadcast('setDocumentRegenerateFlag');   
        $rootScope.$broadcast('refreshBCPSchematics');
        _closeDeleteDialog();
      })
      .catch(() => {
        alerts.error('An error occurred deleting the schematic.');
      });
  }

  function _handleEditedSchematic(newSchematic) { // eslint-disable-line no-unused-vars
    return bcpSharedModelService.getSchematics(vm.assessmentId, true).then((schematics) => {
        angular.extend(vm.schematics, schematics);

        if (vm.addCallback) {
          vm.addCallback()(newSchematic);
        }

        _populateSections();
      });
  }

  function _populateSections() {
    return bcpSharedModelService.getSchematicSections(true)
      .then((sections) => {
        vm.schematics = R.map((schematic) => {
          if (sections && sections.length > 0) {
            const findSection = R.filter(
              R.propEq('schematicSectionId', schematic.schematicSectionId),
              sections
            );
            if (findSection && findSection.length > 0) {
              schematic.sectionName = findSection[0].name;
            }
          }
          return schematic;
        }, vm.schematics);
      });
  }

  function _closeDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteSchematicDialog);
  }
}

SchematicController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  'alerts',
  'userService',
  'bcpDataService',
  'bcpSharedModelService',
  'confirmDialog',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
  'editSchematicDialog',
];
